import axios from 'axios';

export const fetchZipLocation = async (zip: string) => {
  const config = {
    headers: { 'content-type': 'application/json' },
  };

  const response = await axios.get(`/api/cep-location?cep=${zip}`, config);
  return response.data;
};
